import React from 'react';

import { Image, isImage } from '../Image';
import { Rating } from '../Rating/Rating';
import { isVideo, Video } from '../Video';
import { ClientTestimonialCollectionProps } from './ClientTestimonial.types';

export const ClientTestimonial = ({
  entries,
  display = 'Stack',
}: ClientTestimonialCollectionProps): JSX.Element => {
  return (
    <div
      className={`client-testimonials client-testimonials_${display.toLowerCase()}`}
    >
      {entries.map(
        ({ quoteText, byLine, description, media, rating }, index) => (
          <div key={index} className='testimonial'>
            <div className='testimonial__content-wrapper'>
              <div className='testimonial__content'>
                <div className='testimonial__review'>
                  {/* Rating */}
                  {rating && <Rating rating={rating} />}
                  {/* Quote Text */}
                  <p className='testimonial__quote'>{quoteText}</p>
                </div>
                {(byLine || description) && (
                  <div className='testimonial__meta'>
                    {/* Author */}
                    {byLine && (
                      <p className='testimonial__meta_author'>{byLine}</p>
                    )}

                    {/* Author Description */}
                    {description && (
                      <p className='testimonial__meta_content'>{description}</p>
                    )}
                  </div>
                )}
              </div>
            </div>
            {media && (
              <div className='testimonial__media media'>
                {isImage(media) && <Image {...media} />}
                {isVideo(media) && <Video {...media} />}
              </div>
            )}
          </div>
        )
      )}
    </div>
  );
};
